export default __webpack_public_path__ + "static/flipCardImg-433ba992918d8e8e19eecd514db9dd39.webp";